var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "customLoginForm" } },
    [
      _c(
        "div",
        [
          !_vm.customInputsIsValid
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { lg: "12" } },
                    [
                      _c(
                        "a-alert",
                        {
                          key: "alertContainer-" + _vm.$i18n.locale,
                          staticClass: "mb-2",
                          attrs: { showIcon: "", type: "warning" },
                        },
                        [
                          _c(
                            "div",
                            {
                              attrs: { slot: "description" },
                              slot: "description",
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("message.customLoginAlert")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticStyle: { "border-right": "2px solid gray" },
                  attrs: { lg: "4" },
                },
                [
                  _c(
                    "draggable",
                    { attrs: { sort: false } },
                    _vm._l(_vm.formInputs, function (field, i) {
                      return _c(
                        "md-button",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                                theme: _vm.isDarkMode
                                  ? "light-border"
                                  : "google",
                              },
                              expression:
                                "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                            },
                          ],
                          key: i,
                          staticClass: "fields p-0 m-0",
                          attrs: {
                            content: _vm.getFieldDescription(field.type),
                            disabled: _vm.isDisable(field.type),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.addNewInput(field)
                            },
                          },
                        },
                        [
                          _c("md-icon", [_vm._v("add")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                field.type === "subject"
                                  ? _vm.$t("message.department")
                                  : _vm.$t("message." + field.type)
                              )
                            ),
                          ]),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { lg: "8" } },
                [
                  _c(
                    "draggable",
                    {
                      attrs: {
                        id: "list",
                        list: _vm.customInputs,
                        group: "types",
                      },
                      on: { change: _vm.dragChange },
                    },
                    [
                      _vm._l(_vm.customInputs, function (field, i) {
                        return _c("div", { key: i, staticClass: "fields" }, [
                          _c("div", { staticClass: "feature" }, [
                            _c("div", { staticClass: "left" }, [
                              _c("div", { staticClass: "texts" }, [
                                _c("div", { staticClass: "feature-title" }, [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: _vm.isDarkMode
                                              ? "light-border"
                                              : "google",
                                          },
                                          expression:
                                            "{\n                                                followCursor: true,\n                                                placement: 'bottom-end',\n                                                theme: isDarkMode ? 'light-border' : 'google',\n                                            }",
                                        },
                                      ],
                                      staticClass: "infoF",
                                      attrs: {
                                        content: _vm.$t(
                                          "message.doubleClickEdit"
                                        ),
                                      },
                                      on: {
                                        dblclick: function ($event) {
                                          return _vm.handleEdit(field)
                                        },
                                      },
                                    },
                                    [
                                      _c("md-icon", [_vm._v("drag_handle")]),
                                      _vm._v(" "),
                                      field.type !== "label"
                                        ? _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getLocalizedLabel(field)
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                                            :\n                                            "
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            field.type === "subject"
                                              ? _vm.$t("message.department")
                                              : _vm.$t("message." + field.type)
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "right" }, [
                              _c(
                                "div",
                                { staticClass: "actions" },
                                [
                                  _c(
                                    "md-button",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: _vm.isDarkMode
                                              ? "light-border"
                                              : "google",
                                          },
                                          expression:
                                            "{\n                                            followCursor: true,\n                                            placement: 'bottom-end',\n                                            theme: isDarkMode ? 'light-border' : 'google',\n                                        }",
                                        },
                                      ],
                                      attrs: {
                                        content: field.visible
                                          ? _vm.$t("message.visibleField")
                                          : _vm.$t("message.notVisibleField"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleProperty(
                                            field,
                                            "visible"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "md-icon",
                                        {
                                          style: {
                                            color: field.visible
                                              ? "green"
                                              : "gray",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                field.visible
                                                  ? "visibility"
                                                  : "visibility_off"
                                              ) +
                                              "\n                                        "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-button",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: _vm.isDarkMode
                                              ? "light-border"
                                              : "google",
                                          },
                                          expression:
                                            "{\n                                            followCursor: true,\n                                            placement: 'bottom-end',\n                                            theme: isDarkMode ? 'light-border' : 'google',\n                                        }",
                                        },
                                      ],
                                      attrs: {
                                        content: field.required
                                          ? _vm.$t("message.requiredField")
                                          : _vm.$t("message.notRequiredField"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleProperty(
                                            field,
                                            "required"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "md-icon",
                                        {
                                          style: {
                                            color: field.required
                                              ? "goldenrod"
                                              : "gray",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "priority_high\n                                        "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-button",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: _vm.isDarkMode
                                              ? "light-border"
                                              : "google",
                                          },
                                          expression:
                                            "{\n                                            followCursor: true,\n                                            placement: 'bottom-end',\n                                            theme: isDarkMode ? 'light-border' : 'google',\n                                        }",
                                        },
                                      ],
                                      staticClass: "md-primary",
                                      attrs: {
                                        content: _vm.$t("message.edit"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleEdit(field)
                                        },
                                      },
                                    },
                                    [_c("md-icon", [_vm._v("edit")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-button",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: _vm.isDarkMode
                                              ? "light-border"
                                              : "google",
                                          },
                                          expression:
                                            "{\n                                            followCursor: true,\n                                            placement: 'bottom-end',\n                                            theme: isDarkMode ? 'light-border' : 'google',\n                                        }",
                                        },
                                      ],
                                      staticClass: "md-accent",
                                      attrs: {
                                        content: _vm.$t("message.delete"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDelete(field._id)
                                        },
                                      },
                                    },
                                    [_c("md-icon", [_vm._v("delete")])],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ])
                      }),
                      _vm._v(" "),
                      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                        _c(
                          "button",
                          {
                            staticClass: "addButton",
                            on: { click: _vm.addNewInput },
                          },
                          [
                            _c("strong", [_vm._v("+")]),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("message.addNewField")) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isModalShow
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "newFieldModal",
                title: _vm.$t(
                  _vm.editMode ? "message.editField" : "message.addNewField"
                ),
                "show-footer": false,
              },
              on: { cancel: _vm.hideModal },
            },
            [
              _c(
                "div",
                { attrs: { id: "inner-modal" } },
                [
                  (_vm.$validator.errors.items.length ||
                    !_vm.isOneLanguageIncludes()) &&
                  _vm.submitClicked
                    ? _c(
                        "a-alert",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            message: _vm.$t("message.error"),
                            showIcon: "",
                            type: "error",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              attrs: { slot: "description" },
                              slot: "description",
                            },
                            [
                              _vm._l(
                                _vm.$validator.errors.items,
                                function (err) {
                                  return _c("div", [
                                    _c("span", [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(err.msg) +
                                          "\n                        "
                                      ),
                                    ]),
                                  ])
                                }
                              ),
                              _vm._v(" "),
                              !_vm.isOneLanguageIncludes()
                                ? _c("div", [
                                    _c("span", [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$t("message.atLeastOneLanguage")
                                          ) +
                                          "\n                        "
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.handleSubmit.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "mb-1" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("message.name"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'",
                                      },
                                    ],
                                    attrs: {
                                      disabled: [
                                        "email",
                                        "fullname",
                                        "language",
                                      ].includes(_vm.input.type),
                                      name: _vm.$t("message.name"),
                                      trim: "",
                                    },
                                    model: {
                                      value: _vm.input.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.input, "name", $$v)
                                      },
                                      expression: "input.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("message.type"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      attrs: {
                                        name: "type",
                                        disabled: [
                                          "email",
                                          "fullname",
                                          "language",
                                        ].includes(_vm.input.type),
                                      },
                                      model: {
                                        value: _vm.input.type,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.input, "type", $$v)
                                        },
                                        expression: "input.type",
                                      },
                                    },
                                    [
                                      _c(
                                        "option",
                                        { attrs: { value: "text" } },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(_vm.$t("message.text")) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "label" } },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(_vm.$t("message.label")) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "check" } },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(_vm.$t("message.check")) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "numeric" } },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$t("message.numeric")
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "phone" } },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(_vm.$t("message.phone")) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "select" } },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(_vm.$t("message.select")) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "city" } },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(_vm.$t("message.city")) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "cityAndDistrict" } },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$t("message.cityDistrict")
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mb-1" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("message.match"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      attrs: { name: "key" },
                                      model: {
                                        value: _vm.input.contactProperty,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.input,
                                            "contactProperty",
                                            $$v
                                          )
                                        },
                                        expression: "input.contactProperty",
                                      },
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          attrs: { default: "" },
                                          domProps: { value: null },
                                        },
                                        [_vm._v("-")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.visitorAttributes,
                                        function (attribute) {
                                          return _c(
                                            "option",
                                            {
                                              domProps: {
                                                value: attribute._id,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(attribute.label) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-col"),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mb-1" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("span", { attrs: { id: "visibilityid" } }, [
                                _vm._v(_vm._s(_vm.$t("message.visible"))),
                              ]),
                              _vm._v(" "),
                              _c("md-switch", {
                                attrs: { name: "visible" },
                                model: {
                                  value: _vm.input.visible,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.input, "visible", $$v)
                                  },
                                  expression: "input.visible",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("span", { attrs: { id: "requiredid" } }, [
                                _vm._v(_vm._s(_vm.$t("message.required"))),
                              ]),
                              _vm._v(" "),
                              _c("md-switch", {
                                attrs: { name: "required" },
                                model: {
                                  value: _vm.input.required,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.input, "required", $$v)
                                  },
                                  expression: "input.required",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.input.type === "label"
                        ? _c("MultiContent", {
                            ref: "MultiContent",
                            model: {
                              value: _vm.inputInitialObjectContent,
                              callback: function ($$v) {
                                _vm.inputInitialObjectContent = $$v
                              },
                              expression: "inputInitialObjectContent",
                            },
                          })
                        : _c(
                            "b-tabs",
                            { staticClass: "mb-1" },
                            [
                              _c("label", { staticClass: "pt-1" }, [
                                _vm._v(_vm._s(_vm.$t("message.label"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { staticClass: "mt-1" },
                                [
                                  _c("MultiContent", {
                                    ref: "MultiContent",
                                    model: {
                                      value: _vm.inputInitialObjectTitle,
                                      callback: function ($$v) {
                                        _vm.inputInitialObjectTitle = $$v
                                      },
                                      expression: "inputInitialObjectTitle",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                      _vm._v(" "),
                      _vm.input.type === "select"
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "max-height": "300px",
                                "overflow-y": "scroll",
                                "overflow-x": "hidden",
                              },
                            },
                            [
                              _c(
                                "b-row",
                                { staticClass: "mt-1" },
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(_vm.$t("message.options"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.input.options,
                                        function (option, i) {
                                          return _c(
                                            "b-row",
                                            { key: i },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "d-flex align-items-center",
                                                },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    [
                                                      _c("b-form-radio", {
                                                        attrs: {
                                                          value:
                                                            _vm.input.options[
                                                              i
                                                            ],
                                                          name: "defaultOption",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.input
                                                              .defaultOption,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.input,
                                                              "defaultOption",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "input.defaultOption",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-group",
                                                    { staticClass: "w-100" },
                                                    [
                                                      _c("b-form-input", {
                                                        directives: [
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: "required",
                                                            expression:
                                                              "'required'",
                                                          },
                                                        ],
                                                        attrs: {
                                                          name: "options-" + i,
                                                          placeholder: _vm.$t(
                                                            "message.optionsPlaceholder"
                                                          ),
                                                          trim: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.input.options[
                                                              i
                                                            ],
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.input.options,
                                                              i,
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "input.options[i]",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "md-button",
                                                    {
                                                      staticClass: "mb-4",
                                                      staticStyle: {
                                                        width: "42px",
                                                        "min-width": "42px",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.input.options.splice(
                                                            i,
                                                            1
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("md-icon", [
                                                        _vm._v("delete"),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c(
                                        "md-button",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.input.options.push("")
                                            },
                                          },
                                        },
                                        [_c("md-icon", [_vm._v("add")])],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("b-col", { attrs: { md: "12" } }, [
                        _c(
                          "div",
                          { attrs: { id: "buttons" } },
                          [
                            _c("b-button", { on: { click: _vm.hideModal } }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("message.cancel")) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              { attrs: { type: "submit", variant: "primary" } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.editMode
                                        ? _vm.$t("message.update")
                                        : _vm.$t("message.save")
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }